import React from 'react'
import { Language, Text } from '../language'
import { LanguageContext } from '../contexts'
import classNames from 'classnames'

// TODO: generalize into a toggle component

export function LanguageToggle() {
	return (
		<div className='language-toggle field has-addons'>
			<LanguageButton buttonLanguage='English' />
			<LanguageButton buttonLanguage='French' />
		</div>
	)
}

export default LanguageToggle

export interface LanguageButtonProps {
	buttonLanguage: Language
}

function LanguageButton(props: LanguageButtonProps) {
	const { language, setLanguage } = React.useContext(LanguageContext)
	const buttonClass = classNames('button', 'is-small', {'is-active': props.buttonLanguage === language})

	return (
		<div className='control'>
			<button className={buttonClass} onClick={() => setLanguage?.(props.buttonLanguage)}>
				<span>{Text[props.buttonLanguage][props.buttonLanguage]}</span>
			</button>
		</div>
	)
}